import React, { Component } from "react";
import PropTypes from "prop-types";
import h2p from "html2plaintext";
import Heading from "~/scripts/components/Heading";
import Next from "~/scripts/components/Next";
import Previous from "~/scripts/components/Previous";
import VideoGallery from "~/scripts/components/VideoGallery";
import BodyCopy from "~/scripts/components/BodyCopy";
import FadeUp from "~/scripts/components/transitions/FadeUp";
import NotFound from "~/scripts/components/pages/NotFound";
import { w } from "~/scripts/utils/w";

class Director extends Component {
    static propTypes = {
        slug: PropTypes.string,
        location: PropTypes.shape({
            state: PropTypes.object,
            key: PropTypes.string
        }),
        onMount: PropTypes.func,
        onChange: PropTypes.func,
        friend: PropTypes.bool
    };

    constructor(props) {
        super(props);

        this.state = {
            data: {}
        };

        this.nextRef = React.createRef();
        this.prevRef = React.createRef();
        this.w = w();

        this.load = this.load.bind(this);
    }

    componentDidMount() {
        const { slug, onMount, location } = this.props;

        if (onMount) {
            onMount(location.state && location.state.theme);
        }

        this.load(slug);
    }

    async load(slug) {
        const { friend } = this.props;
        const url = friend ? "friends" : "directors";
        const response = await fetch(`/api/${url}/${slug}`);

        const data = await response.json();

        // TODO: fix merging of properties resulting in incorrect next value
        this.setState({ data });
    }

    render() {
        const { data } = this.state;
        const {
            friend,
            headingPos,
            state,
            toggleSpecialPageTransition,
            transitionDirection,
            location,
            slug
        } = this.props;

        let transitionX = null;
        let transitionY = null;

        if (state === "exiting") {
            if (transitionDirection === "previous") {
                const rect = this.prevRef.current.getBoundingClientRect();
                transitionY = this.w.h;
                transitionX = this.w.w - rect.left;
            }

            if (transitionDirection === "next") {
                const rect = this.nextRef.current.getBoundingClientRect();
                transitionY = headingPos.height - rect.top;
                transitionX = headingPos.left - rect.left;
            }
        }

        if (state === "entering") {
            if (transitionDirection === "next") {
                const rect = this.nextRef.current.getBoundingClientRect();
                transitionY = this.w.h - rect.top;
                transitionX = this.w.w - rect.left;
            }
        }

        if (data.error) {
            return <NotFound />;
        }

        const { title, bodyCopy, prev, next, films } = data;
        const description = h2p(bodyCopy)
            .split("\n\n", 1)[0]
            .trim();

        return (
            <div className="page-wrapper">
                <div
                    className="director"
                    style={{
                        transform:
                            transitionX !== null && transitionY !== null
                                ? `translate3d(${transitionX}px, ${transitionY}px, 0)`
                                : ""
                    }}
                >
                    <div className="director__head" ref={this.prevRef}>
                        <div className="director__sub">
                            <Previous
                                prev={prev}
                                title={friend ? "Friend" : "Director"}
                                toggleSpecialPageTransition={
                                    toggleSpecialPageTransition
                                }
                            />
                        </div>

                        <div className="director__heading">
                            <Heading>{title}</Heading>
                        </div>
                    </div>

                    <div className="director__body">
                        <div className="director__gallery">
                            <VideoGallery
                                initialFilmId={
                                    location.state && location.state.id
                                }
                                entryType={friend ? "friends" : "directors"}
                                directorSlug={slug}
                                films={films}
                                toggleSpecialPageTransition={
                                    toggleSpecialPageTransition
                                }
                            />
                        </div>

                        <div className="director__biography">
                            <FadeUp>
                                <BodyCopy>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: bodyCopy
                                        }}
                                    />
                                </BodyCopy>
                            </FadeUp>
                        </div>
                    </div>

                    <div className="director__next" ref={this.nextRef}>
                        <Next
                            next={next}
                            title={friend ? "Friend" : "Director"}
                            toggleSpecialPageTransition={
                                toggleSpecialPageTransition
                            }
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default Director;



// WEBPACK FOOTER //
// ./src/scripts/components/pages/Director.js